export const PRODUCT = {
  name: "Knocky",
  domain: "knocky.app",
  supportEmail: "support@knocky.app",
  appUrl: process.env.GATSBY_APP_ORIGIN || "https://platform.knocky.app",
  analyticsId: "G-5MGKNSY4LW",
  metaPixelId: process.env.GATSBY_META_PIXEL_ID || "",
  brandHue: 220,
} as const;
